// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, ".folder-input[data-v-4c9a8b3a] {\n    width: 50%\n}", "",{"version":3,"sources":["/app/app/javascript/dashboard/routes/dashboard/contacts/components/ContactsAdvancedFilters.vue"],"names":[],"mappings":"AAEE;IAAA;AAAA","file":"ContactsAdvancedFilters.vue","sourcesContent":["\n.folder-input {\n  @apply w-[50%];\n}\n"]}]);
// Exports
module.exports = exports;
